import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface DiaryLineProps {
  /** Timestamp shown in the gutter. Pass a static `"09:14"` for demo entries
   *  or a `<LiveTimestamp />` element for live anchor lines. Omit for
   *  rows that should align with the gutter but carry no time. */
  time?: ReactNode;
  /** Override the gutter content's tabindex / aria treatment. The gutter is
   *  decorative by default (`aria-hidden`); set to false on rare cases where
   *  the time itself is the content. */
  hideGutterFromAT?: boolean;
  className?: string;
  contentClassName?: string;
  children: ReactNode;
}

export function DiaryLine({
  time,
  hideGutterFromAT = true,
  className,
  contentClassName,
  children,
}: DiaryLineProps) {
  return (
    <div
      className={cn(
        'grid grid-cols-[48px_1fr] items-baseline gap-x-2 sm:grid-cols-[56px_1fr] sm:gap-x-2',
        className,
      )}
    >
      <div
        aria-hidden={hideGutterFromAT}
        className="font-mono text-xs leading-none text-muted-foreground/80 transition-colors hover:text-muted-foreground"
      >
        {time}
      </div>
      <div className={cn('min-w-0', contentClassName)}>{children}</div>
    </div>
  );
}
